export const ENDED_CHAT = 'Ended Chat';
export const ADMINISTRATIVE_USER_CHAT = 'Administrative User Chat';

export const getAgencyName = (hasChatEnded, entityDisplayName) => {
  if (hasChatEnded) {
    return 'Ended Chat';
  } else if (entityDisplayName) {
    return entityDisplayName;
  } else {
    return 'Administrative User Chat';
  }
};
